<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
    <p [innerHtml]="bodyHtml"></p>
</mat-dialog-content>
<mat-dialog-actions align="end" [class.matDialogDiv]="component">
    <button 
        mat-raised-button 
        type="button" 
        class="deleteAndCancelButton"
        *ngIf="cancelText !== null"
        (click)="cancel()">
        {{ cancelText }}
    </button>
    <button 
        mat-raised-button 
        type="button" 
        color="warn" 
        (click)="assent()">
        {{ confirm }}
    </button>
</mat-dialog-actions>
